import ArchiveA from "../images/archive/archive_a.png";
import ArchiveB from "../images/archive/archive_b.png";
import ArchiveC from "../images/archive/archive_c.png";
import ArchiveD from "../images/archive/archive_d.png";
import ArchiveE from "../images/archive/archive_e.png";
import ArchiveF from "../images/archive/archive_f.png";

{
  /* TODO: Clean up imports */
}

const headers = [
  [ArchiveA, "Homecoming Game", "1985", "Football"],
  [ArchiveB, "All Right Now", "1993", "Football"],
  [ArchiveC, "Come Join", "1998", "Football"],
  [ArchiveD, "Rose Bowl", "1998", "Football"],
  [ArchiveE, "Kathy & Judy", "2008", "45th Class Reunion"],
  [ArchiveF, "Homecoming Reunion", "2011", "Basketball"],
];

{
  /* Make this less brute force */
}

export const increments = [
  [
    "1950-1951",
    "1951-1952",
    "1952-1953",
    "1953-1954",
    "1954-1955",
    "1955-1956",
    "1956-1957",
    "1957-1958",
    "1958-1959",
    "1959-1960",
  ],
  [
    "1960-1961",
    "1961-1962",
    "1962-1963",
    "1963-1964",
    "1964-1965",
    "1965-1966",
    "1966-1967",
    "1967-1968",
    "1968-1969",
    "1969-1970",
  ],
  [
    "1970-1971",
    "1971-1972",
    "1972-1973",
    "1973-1974",
    "1974-1975",
    "1975-1976",
    "1976-1977",
    "1977-1978",
    "1978-1979",
    "1979-1980",
  ],
  [
    "1980-1981",
    "1981-1982",
    "1982-1983",
    "1983-1984",
    "1984-1985",
    "1985-1986",
    "1986-1987",
    "1987-1988",
    "1988-1989",
    "1989-1990",
  ],
  [
    "1990-1991",
    "1991-1992",
    "1992-1993",
    "1993-1994",
    "1994-1995",
    "1995-1996",
    "1996-1997",
    "1997-1998",
    "1998-1999",
    "1999-2000",
  ],
  [
    "2000-2001",
    "2001-2002",
    "2002-2003",
    "2003-2004",
    "2004-2005",
    "2005-2006",
    "2006-2007",
    "2007-2008",
    "2008-2009",
    "2009-2010",
  ],
  [
    "2010-2011",
    "2011-2012",
    "2012-2013",
    "2013-2014",
    "2014-2015",
    "2015-2016",
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
  ],
  [
    "2020-2022",
    "2022-2023",
    "2023-2024",
    "2024-2025",
    "2025-2026",
    "2026-2027",
    "2027-2028",
    "2028-2029",
    "2029-2030",
    "2030-2031",
  ],
];

export default headers;
